<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'employees')" class="tab__footer page__active_bar">
      <el-button
        id="addClient"
        class="page__active_button"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push({ name: 'user:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
    <div class="page_container">
      <search :query.sync="query" @search="search" />
      <el-table id="listMediaServers" class="list list_users" :data="items">
        <el-table-column prop="client_name" label="Полное имя">
          <template slot-scope="scope">
            <router-link class="link" :to="`/user/edit/${scope.row.id_account}`">
              {{ scope.row.client_name || "Нет данных" }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="Email" />
        <el-table-column prop="email_notification" label="Подписка на уведомления" align="center">
          <template slot-scope="scope">
            <fa
              :icon="['fas', scope.row.email_notification ? 'check' : 'times']"
              :style="{ color: scope.row.email_notification ? 'green' : 'red' }"
            />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import list from "@/core/mixins/list";

export default {
  name: "UsersList",
  components: {
    search: Search,
  },
  mixins: [list],
  data() {
    return { query: "" };
  },
  computed: {
    ...mapState("users", {
      items: (state) => state.data,
      total: (state) => state.total,
      count: (state) => state.count,
    }),
    ...mapGetters("users", ["getQuery"]),
  },
  methods: {
    ...mapActions("users", {
      getList: "GET_LIST_USERS",
    }),
    ...mapMutations("users", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.el-table th > .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
.list_users .cell {
  word-break: normal;
}
</style>
